import { SymbolLayerSpecification } from 'mapbox-gl';

import { FeatureTypeEnum, LayerNameEnum, SourceNameEnum } from '@/types/map.types';

export const engagedTargetLayer: SymbolLayerSpecification = {
  id: LayerNameEnum.ENGAGED_TARGET,
  type: 'symbol',
  source: SourceNameEnum.ENGAGEMENT,
  filter: ['==', 'featureType', FeatureTypeEnum.ENGAGED_TARGET_ICON],
  layout: {
    'icon-image': ['get', 'icon'],
    'icon-size': 0.6,
    'icon-allow-overlap': true,
    'icon-ignore-placement': true,
    'icon-pitch-alignment': 'viewport',
    'icon-rotation-alignment': 'viewport',
    'symbol-z-order': 'source',
    'icon-rotate': ['coalesce', ['get', 'heading'], 0],
  },
  paint: {
    'icon-opacity': ['case', ['coalesce', ['feature-state', 'blinkOn'], false], 0, 1],
  },
};

export const engagedTargetBlinkingLayer: SymbolLayerSpecification = {
  ...engagedTargetLayer,
  id: LayerNameEnum.ENGAGED_TARGET_CONTINGENCY,
  layout: {
    ...engagedTargetLayer.layout,
    'icon-image': ['get', 'contingencyIcon'],
    'icon-rotate': 0,
  },
  paint: {
    'icon-opacity': ['case', ['coalesce', ['feature-state', 'blinkOn'], false], 1, 0],
  },
};

export const engagedCircleLayer: SymbolLayerSpecification = {
  id: LayerNameEnum.ENGAGED_CIRCLE,
  type: 'symbol',
  source: SourceNameEnum.ENGAGEMENT,
  filter: ['==', 'featureType', FeatureTypeEnum.ENGAGEMENT_CIRCLE],
  layout: {
    'icon-image': ['get', 'icon'],
    'icon-size': 0.6,
    'icon-allow-overlap': true,
    'icon-ignore-placement': true,
    'icon-pitch-alignment': 'viewport',
    'icon-rotation-alignment': 'viewport',
    'symbol-z-order': 'source',
  },
};

export const engagedSelectedTargetLayer: SymbolLayerSpecification = {
  id: LayerNameEnum.ENGAGED_TARGET_SELECTION,
  type: 'symbol',
  source: SourceNameEnum.SELECTION,
  filter: ['==', 'featureType', FeatureTypeEnum.ENGAGED_TARGET_ICON],
  layout: {
    'icon-image': ['get', 'icon'],
    'icon-size': 0.6,
    'icon-allow-overlap': true,
    'icon-ignore-placement': true,
    'icon-pitch-alignment': 'viewport',
    'icon-rotation-alignment': 'viewport',
    'symbol-z-order': 'source',
    'icon-rotate': ['coalesce', ['get', 'heading'], 0],
  },
  paint: {
    'icon-opacity': ['case', ['coalesce', ['feature-state', 'blinkOn'], false], 0, 1],
  },
};

export const engagedSelectedTargetBlinkingLayer: SymbolLayerSpecification = {
  ...engagedSelectedTargetLayer,
  id: LayerNameEnum.ENGAGED_TARGET_SELECTION_CONTINGENCY,
  layout: {
    ...engagedSelectedTargetLayer.layout,
    'icon-image': ['get', 'contingencyIcon'],
    'icon-rotate': 0,
  },
  paint: {
    'icon-opacity': ['case', ['coalesce', ['feature-state', 'blinkOn'], false], 1, 0],
  },
};

export const engagedSelectedCircleLayer: SymbolLayerSpecification = {
  id: LayerNameEnum.ENGAGED_CIRCLE_SELECTION,
  type: 'symbol',
  source: SourceNameEnum.SELECTION,
  filter: ['==', 'featureType', FeatureTypeEnum.ENGAGEMENT_CIRCLE],
  layout: {
    'icon-image': ['concat', ['get', 'icon'], '-halo'],
    'icon-size': 0.6,
    'icon-allow-overlap': true,
    'icon-ignore-placement': true,
    'icon-pitch-alignment': 'viewport',
    'icon-rotation-alignment': 'viewport',
    'symbol-z-order': 'source',
  },
};
